"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SendSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M8.11534537,9.88465463 L3.33862892,7.97396805 C2.88628108,7.75214312 2.88628108,7.22000493 3.35374921,7.02115029 L14.30899,3.03742635 C14.9259186,2.88208008 15.0654144,3.39814758 14.9625736,3.69100996 L10.9788497,14.6462508 C10.7462616,15.1931458 10.1464466,15.0178833 10.0260319,14.6613711 L8.11534537,9.88465463 Z M8.37957836,8.91331486 L10.1464466,7.14644661 C10.3417088,6.95118446 10.6582912,6.95118446 10.8535534,7.14644661 C11.0488155,7.34170876 11.0488155,7.65829124 10.8535534,7.85355339 L9.08668514,9.62042164 L10.4777531,13.0980915 L13.66395,4.33604999 L4.90190848,7.52224691 L8.37957836,8.91331486 Z" })));
};
SendSmall.displayName = 'SendSmall';
exports.default = SendSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SendSmall.js.map